import React from "react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

import listStyles from "../../../../../SwmsMasters/PreStartQuestions/MethodQuestionsStyle.module.css";
import JobSwmsV3DraggablePreStartQuestionRow from "./JobSwmsV3DraggablePreStartQuestionRow";

export default function JobSwmsV3PreStartQuestionsList({
  questions = [],
  visibleOrders = [],
  reorderDisabled = false,
  moveQuestionRow = () => {},
  onAfterDropQuestionRow = () => {},
  onOpenEditQuestion = () => {}
}) {
  return (
    <DndProvider backend={HTML5Backend}>
      <div className={listStyles.MethodQuestionList}>
        {questions.map((question = {}, index) => (
          <JobSwmsV3DraggablePreStartQuestionRow
            key={question.id || `question-row-${index}`}
            question={question}
            index={index}
            visibleOrder={visibleOrders[index]}
            reorderDisabled={reorderDisabled}
            moveQuestionRow={moveQuestionRow}
            onAfterDropQuestionRow={onAfterDropQuestionRow}
            onOpenEditQuestion={onOpenEditQuestion}
          />
        ))}
      </div>
    </DndProvider>
  );
}
